<template>
  <div class="legenda-prospeccao">
    <span class="legenda-titulo">Sobre os equipamentos:</span>

    <div class="legenda-grid">
      <!-- FOG -->
      <div class="legenda-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#64748b"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="legenda-icon"
        >
          <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
          <path d="M22 19v1" />
          <path d="M22 15v2" />
          <path d="M18 19v1" />
          <path d="M18 15v2" />
        </svg>
        <div class="legenda-texto">
          <span class="legenda-nome">FOG</span>
          <span class="legenda-desc">
            Termonebulização
            <span
              class="tooltip-wrapper"
              title="O FOG (Termonebulização) utiliza calor para transformar o inseticida em névoa densa. Muito eficaz contra insetos voadores como mosquitos e moscas em locais de difícil acesso, forros e frestas. Requer equipamento transportado em carro."
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#94a3b8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="cursor: pointer"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            </span>
          </span>
        </div>
      </div>

      <!-- UBV -->
      <div class="legenda-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#64748b"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="legenda-icon"
        >
          <path
            d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"
          />
        </svg>
        <div class="legenda-texto">
          <span class="legenda-nome">UBV</span>
          <span class="legenda-desc">
            Ultra Baixo Volume
            <span
              class="tooltip-wrapper"
              title="O UBV (Ultra Baixo Volume) pulveriza gotículas extremamente finas no ar, formando uma névoa que atinge insetos voadores em suspensão. É ideal para controle do Aedes aegypti e outros vetores. Assim como o FOG, requer equipamento transportado em carro."
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#94a3b8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="cursor: pointer"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            </span>
          </span>
        </div>
      </div>

      <!-- Escada -->
      <div class="legenda-item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#64748b"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="legenda-icon"
        >
          <line x1="8" y1="3" x2="8" y2="21" />
          <line x1="16" y1="3" x2="16" y2="21" />
          <line x1="8" y1="7" x2="16" y2="7" />
          <line x1="8" y1="11" x2="16" y2="11" />
          <line x1="8" y1="15" x2="16" y2="15" />
          <line x1="8" y1="19" x2="16" y2="19" />
        </svg>
        <div class="legenda-texto">
          <span class="legenda-nome">Escada</span>
          <span class="legenda-desc">
            Acesso em altura
            <span
              class="tooltip-wrapper"
              title="O uso de escada é necessário quando o serviço exige acesso a locais elevados, como forros, telhados ou áreas altas. Por isso requer transporte em carro."
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#94a3b8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="cursor: pointer"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LegendasForcaTrabalhoProspeccaoResponsive",
};
</script>

<style scoped>
.legenda-prospeccao {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.legenda-titulo {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569;
}

.legenda-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.legenda-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 10px;
}

.legenda-icon {
  flex-shrink: 0;
}

.legenda-texto {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.legenda-nome {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.legenda-desc {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  color: #6b7280;
}

/* Responsivo: em telas pequenas empilha em 1 coluna */
@media (max-width: 640px) {
  .legenda-grid {
    grid-template-columns: 1fr;
  }
}

/* Telas médias: 2 colunas */
@media (min-width: 641px) and (max-width: 900px) {
  .legenda-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
